module.exports = __webpack_public_path__ + "media/img/apple-icon-593f64d227a7f0fd6691d6bebe47c40c.png";